import React from "react";
import Button from "../framework/Button";

function CardListObj(props) {
  let i = 0;
  // function defaultButton1Action(e, id, link, functionName) {
  //   console.log(e, id, link, functionName);

  //   if (props.button1Action === undefined || props.button1Action === null) {
  //   } else {
  //     //props.button1Action(id);
  //   }
  // }

  return (
    <div className="CardList_box">
      {props.data.map((item, index) => (
        <div className="CardList_item">
          <div>
            <div className="CardList_layout">
              <div
                className="CardList_icon"
                style={
                  item.icons
                    ? {
                        content: `url('${
                          item.icons[item.status.toString().toLowerCase()]
                        }')`
                      }
                    : {
                        content: `url('../assets/logo_BCHtagline.svg')`
                      }
                }
              ></div>
              <div>
                <div
                  className="CardList_label"
                  style={
                    item.label !== undefined && item.label.length > 0
                      ? {}
                      : { display: "none" }
                  }
                >
                  {item.label}
                </div>
                <div
                  className="CardList_status"
                  style={
                    item.label !== undefined && item.label.length > 0
                      ? {}
                      : { display: "none" }
                  }
                >
                  {item.content}
                </div>
              </div>
            </div>
            <div
              style={
                item.status.toString().toLowerCase() === "completed"
                  ? { display: "none" }
                  : {}
              }
            >
              <Button
                text={item.button1Label.trim()===""?"IN PROGRESS":item.button1Label}
                styleName={
                  item.buttonStyle !== undefined && item.buttonStyle.length > 0
                    ? item.button1Style
                    : "button button--primary"
                }
                id={"CardList_button_" + item.id + "_" + i++}
                type="submit"
                isDisabled={item.button1IsDisabled}
                onClick={(e) => {
                  item.button1function({ id: item.id, link: item.contentLink });
                }}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CardListObj;
